<mat-card>
    <div class="page-header">
      <img [src]="'https://assets.liumex.com/resources/esportsms/content/es-stage.png'" alt="" fill priority>
      <div>EsportsMS</div>
    </div>
    <mat-card-content>
      <p>The EsportsMS is designed to revolutionize the way you manage Esports tournaments. Organizers worldwide choose EsportsMS to 
        simplify their tournament operations. Unlock the full potential of your Esports journey with a platform designed to inspire 
        excellence and redefine standards.  Whether you're a seasoned organizer or diving into your first tournament, EsportsMS 
        empowers you with tools that anticipate your needs and elevate your capabilities.</p>
      <mat-divider></mat-divider>
      <mat-card-title>Revolutionize Your Workflow</mat-card-title>
      <p>Say goodbye to scattered spreadsheets and fragmented communication. EsportsMS consolidates your tournament operations 
        into one seamless platform. From competition and team management to scheduling and results tracking, our intuitive interface 
        ensures every detail is managed effortlessly.</p>
      <mat-divider></mat-divider>
      <mat-card-title>Empower Collaboration</mat-card-title>
      <p>Built-in collaboration tools facilitate teamwork like never before. Coordinate across all departments with ease. Real-time updates keep everyone informed, ensuring smooth and synchronized event execution.</p>
      <mat-divider></mat-divider>
      <mat-card-title>Commitment to Innovation</mat-card-title>
      <p>We continuously evolve our platform based on user feedback and industry trends. Join a community of forward-thinking organizers 
        who trust EsportsMS to stay ahead in the competitive esports landscape.</p>
      <!-- <button mat-raised-button routerLink="pricing" color="primary">GET STARTED</button> -->
    </mat-card-content>
  </mat-card>